import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output } from '@angular/core';
import { WorkNote } from '../../data/work-note';


import { FormatPipe } from '@softline/ui-core';
@Component({
    selector: 'lib-work-note-card',
    templateUrl: './work-note-card.component.html',
    styleUrls: ['./work-note-card.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    FormatPipe
  ]
})
export class WorkNoteCardComponent {
  @Output() tapped = new EventEmitter<WorkNote>();
  @Input() workNote?: WorkNote;

  constructor() {}
}
